import { required, optional, array, obj } from 'AppReact/schema';

const admin_note = {
  admin: required('string'),
  admin_id: required('integer'),
  email: optional('string'),
  id: required('integer'),
  inserted_at: required('jsDate'),
  note: required('string')
}

const attachment = {
  content_type: required('string'),
  id: required('integer'),
  inserted_at: required('jsDate'),
  url: required('string')
}

const cost = {
  amount: required('number'),
  id: required('integer'),
  category_name: required('string')
}

const param = {
  amount: optional('number'),
  payee_id: optional('integer'),
  description: optional('string')
}

const requestor = {
  email: optional('string'),
  id: optional('integer'),
  name: optional('string')
}

const log = {
  admin: required('string'),
  admin_id: required('integer'),
  email: required('string'),
  id: optional('integer'),
  inserted_at: required('jsDate'),
  notes: optional('string'),
  status: required('string'),
}

export default {
  admin_notes: array(obj(admin_note)),
  attachments: array(obj(attachment)),
  costs: array(obj(cost)),
  property_id: required('integer'),
  id: required('integer'),
  vendor_name: required('string'),
  inserted_at: required('jsDate'),
  logs: array(obj(log)),
  notes: optional('string'),
  num: optional('string'),
  params: obj(param),
  property: optional('string'),
  requestor: obj(requestor),
  type: optional('string'),
};
